import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ParallaxProvider } from 'react-scroll-parallax';

// Import all your screens
import HomeScreen from './screens/HomeScreen';
import StoreScreen from './screens/StoreScreen';
import ProductDetailScreen from './screens/ProductDetailScreen';
import CheckoutScreen from './screens/CheckoutScreen';
import { CartProvider } from './context/CartContext';
import ThankYouScreen from './screens/ThankYouScreen';
import MenuScreen from './screens/MenuScreen';
import DrinkDetailScreen from './screens/DrinkDetailScreen';
import BlogScreen from './screens/BlogScreen';
import BlogDetailScreen from './screens/BlogDetailScreen';
import OurBrandScreen from './screens/OurBrandScreen'; 
import FranchiseScreen from './screens/FranchiseScreen';
import CareersScreen from './screens/CareersScreen'
import ComingSoonScreen from './screens/ComingSoonScreen';
import ScrollToTop from './components/ScrollToTop';
import TrainingScreen from './screens/TrainingScreen';
import ProgramDetailScreen from './screens/ProgramDetailScreen';
import CourseDetailScreen from './screens/CourseDetailScreen';
import SubscriptionScreen from './screens/SubscriptionScreen';
import MembershipViewScreen from './screens/MembershipViewScreen';
import MembershipVerifyScreen from './screens/MembershipVerifyScreen';

import './App.css';

function App() {
  return (
    // Wrap the entire application in BrowserRouter
    <BrowserRouter>
      <div className="App">
        {/* The Routes component manages the routing logic */}
        <CartProvider>
        <ScrollToTop />
        <Routes>
          {/* Route for the Home page */}
          <Route path="/" element={<HomeScreen />} />

          {/* Route for the Store page */}
          <Route path="/store" element={<StoreScreen />} />

          {/* Route for a single Product Detail page */}
          <Route path="/product/:productId" element={<ProductDetailScreen />} />
          <Route path="/checkout" element={<CheckoutScreen />} />
          <Route path="/thank-you" element={<ThankYouScreen />} />
          <Route path="/menu" element={<MenuScreen />} />
          <Route path="/menu/:drinkId" element={<DrinkDetailScreen />} />
          <Route path="/blog" element={<BlogScreen />} /> {/* <-- ADD THIS */}
          <Route path="/blog/:blogId" element={<BlogDetailScreen />} /> 
          <Route path="/our-brand" element={<OurBrandScreen />} />
           <Route path="/franchise" element={<FranchiseScreen />} /> {/* <-- ADD ROUTE */}
           <Route path="/carrers" element={<CareersScreen />} /> {/* <-- ADD ROUTE */}
           <Route path="/subscription" element={<SubscriptionScreen />} />
            <Route path="/loyalty" element={<ComingSoonScreen />} />
            <Route path="/comingsoon" element={<ComingSoonScreen />} />
            <Route path="/training" element={<TrainingScreen />} />
            <Route path="/training/:programId" element={<ProgramDetailScreen />} />
            <Route path="/training/course/:courseId" element={<CourseDetailScreen />} />
            <Route path="/subscription" element={<SubscriptionScreen />} />
            <Route path="/membership/view" element={<MembershipViewScreen />} />
            <Route path="/membership/verify" element={<MembershipVerifyScreen />} />
        </Routes>
        </CartProvider>
      </div>
    </BrowserRouter>
  );
}

export default App;